export default function anchorTransition() {

	$(document).on('click', 'a[href^="#"]', function (e) {
		var $target = $($(this).attr('href'));
		if (!$target.length || $target.hasClass('modal')) {
			return false;
		}
		$('html, body').animate({ scrollTop: $target.offset().top }, 800);
	});

	// плавный переход к якорю
	$("body").on('click', '.Button_to-top__js', function (e) {
		e.preventDefault();
		$('html,body').stop().animate({ scrollTop: 0 }, 500);
	});
}